import { FC, useCallback } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"
import { AlertVitals } from "@/types/alert"
import { isUndefined } from "@/utils/lodash"

interface AlertStatusIconProps {
   typeface: IconColor
   alertKey: string
   vitals: {
      low: AlertVitals["lowHeartRate"] | AlertVitals["lowRespiratoryRate"]
      high: AlertVitals["highHeartRate"] | AlertVitals["highRespiratoryRate"]
   }
}

const AlertStatusIcon: FC<AlertStatusIconProps> = ({
   typeface,
   alertKey,
   vitals,
}) => {
   const { low, high } = vitals || {}

   const getThresholdIcon = useCallback(
      (high?: boolean, low?: boolean) => {
         if (isUndefined(high) || isUndefined(low)) {
            return ""
         }
         if (!high && !low) {
            return ""
         }

         return (
            <Icon
               className="alert-card__vital-status-icon"
               {...(high && {
                  "data-testid": TestId.ALERT_CARD_UPPER_THRESHOLD_ICON,
               })}
               name={high ? "upperThreshold" : "lowerThreshold"}
               color={typeface}
               size="16"
            />
         )
      },
      [typeface]
   )

   return (
      (low || high) && (
         <span className="alert-card__status-icon">
            <Icon
               className="alert-card__vital-icon"
               {...(alertKey === "bpm" && {
                  "data-testid": TestId.ALERT_CARD_HEART_RATE_ICON,
               })}
               name={alertKey === "bpm" ? "heartRate" : "respiratoryRate"}
               color={typeface}
               size="16"
            />
            {getThresholdIcon(high, low)}
         </span>
      )
   )
}

export default AlertStatusIcon
